import React from "react"
import { fnFormatAttachment } from '@ekuaibao/lib/lib/lib-util'

// 定义发票表单类型
interface InvoiceForm {
  attachments?: any[]
  invoices?: any[]
}

// 定义组件 props 类型
interface GetInvoiceStateTextProps {
  invoiceFormState?: string
  invoiceForm?: InvoiceForm
}

export const invoiceFormMap = (): Record<string, string> => ({
  exist: '已有发票',
  noExist: '无发票',
  wait: '待开发票',
  unify: '统一开票',
  noWrite: '无需填写',
  existConfirm: '已有发票(待确认)'
})

export function parseAsShowValue(fileList: any[], invoiceDetailList: any[]): any[] {
  let files = fnFormatAttachment(fileList)
  files.map((item: any) => (item.type = 'invoicePhoto'))
  return files.concat(invoiceDetailList)
}

export function renderStyle(invoiceForm: any) {
  if (!invoiceForm) return { display: 'none' }
  return Object.keys(invoiceForm).length > 1 &&
    (invoiceForm.type === 'unify' ||
      (invoiceForm.type === 'exist' &&
        ((invoiceForm.attachments && invoiceForm.attachments.length) ||
          (invoiceForm.invoices && invoiceForm.invoices.length))) ||
      ((invoiceForm.type === 'noWrite' || invoiceForm.type === 'exist') &&
        invoiceForm.invoices &&
        invoiceForm.invoices.length))
    ? { maxWidth: 512 }
    : { display: 'none' }
}

export function renderTitle(invoiceForm: any) {
  if (!invoiceForm) return ''
  return invoiceForm.attachments || invoiceForm.fileList ? '' : invoiceForm.invoices ? '' : '开票方'
}

export const GetInvoiceStateText: React.FC<GetInvoiceStateTextProps> = ({ invoiceFormState, invoiceForm }) => {
  if (!invoiceFormState) {
    return null
  }

  let text: string | null = null
  if (invoiceFormState === 'exist') {
    const invoiceLength = invoiceForm ? parseAsShowValue(invoiceForm.attachments || [], invoiceForm.invoices || []).length : 0
    text = `${invoiceFormMap()?.[invoiceFormState]}*${invoiceLength}`
  } else {
    text = invoiceFormMap()?.[invoiceFormState] || null
  }

  return text ? <span>{text}</span> : null
}
